<template>
  <div class="profile-settings">
    <div class="boxclose" @click="close"></div>
    <b-overlay :show="pending" rounded="sm">
      <b-form
        @submit="onFormSubmit"
        accept-charset="utf-8"
        class="overlay_form flashupload"
      >
        <div id="profile-card">
          <header>
            <h3 class="my-4 form-header">
              <i class="fas fa-cogs fa-1x"></i>{{ $t("settings") }}
            </h3>
            <table class="profile-info">
              <tbody>
                <tr>
                  <td><i class="far fa-id-card"></i></td>
                  <td>{{ user.sid }}</td>
                </tr>
                <tr>
                  <td><i class="fas fa-gamepad"></i></td>
                  <td>{{ user.uid }}</td>
                </tr>
                <tr>
                  <td><i class="fas fa-user-circle"></i></td>
                  <td>
                    <div v-if="!isUserNameEdit">
                      <span>{{ user.username }}</span>
                      <i
                        class="sameIcon feIcons far fa-edit pl-2"
                        @click="isUserNameEdit = true"
                      ></i>
                    </div>
                    <div class="CloseInputDiv" v-else>
                      <input
                        type="text"
                        class="userName form-control"
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                        v-model="form.username"
                        maxlength="32"
                        required
                        minlength="6"
                      /><i
                        class="sameIcon fas fa-times pl-1"
                        @click="returnUsername()"
                      ></i>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td><i class="fas fa-envelope"></i></td>
                  <td>{{ user.email }}</td>
                </tr>
              </tbody>
            </table>
            <b-form-invalid-feedback :state="usernameValidation">
              {{ usernameError }}
            </b-form-invalid-feedback>
            <hr class="profile-hr" />
          </header>

          <main>
            <div class="profile-item">
              <div class="profile-label">
                {{ $t("send_newsletter") }}
              </div>
              <label class="profile-switch"
                ><input
                  type="checkbox"
                  name="newsletter"
                  v-model="form.newsletter"
                />
                <div class="profile-slider"></div>
              </label>
            </div>

            <div class="profile-item">
              <div class="profile-label">
                {{ $t("findable") }}
              </div>
              <label class="profile-switch"
                ><input
                  type="checkbox"
                  name="findable"
                  v-model="form.display_in_friendfinder"
                  checked="checked"
                />
                <div class="profile-slider"></div>
              </label>
            </div>

            <div class="profile-item">
              <div class="profile-label">
                {{ $t("language") }}
              </div>
              <label class="language-dropdown-selector my-auto">
                <select
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-model="form.locale"
                  class="form-control"
                >
                  <option
                    v-for="l in supportedLanguages"
                    v-bind:key="l.value"
                    :value="l.value"
                  >
                    {{ l.text }}
                  </option>
                </select>
              </label>
            </div>
            <hr />
            <div class="profile-item">
              <div class="profile-label">
                <a
                  @click="changePassword()"
                  class="link-list text-purple text-transform-none"
                  ><i class="fas fa-key"></i>{{ $t("change_password") }}</a
                >
              </div>
            </div>

            <div class="profile-item" v-if="!isSSO">
              <div class="profile-label">
                <a
                  @click="manageAzerionConnect()"
                  class="link-list text-orange text-transform-none"
                  ><i class="fas fas fa-user-cog"></i
                  >{{ $t("Manage Azerion Connect") }}</a
                >
              </div>
            </div>

            <div class="profile-item">
              <div class="profile-label">
                <a
                  @click="downloadProfile()"
                  class="link-list text-primary text-transform-none"
                >
                  <i class="fas fa-cloud-download-alt"></i
                  >{{ $t("account_download_data") }}</a
                >
              </div>
            </div>

            <div class="profile-item" v-if="!isSSO">
              <div class="profile-label">
                <a
                  @click="deleteAccount()"
                  class="link-list text-danger text-transform-none"
                  ><i class="fas fa-trash"></i>{{ $t("delete_account") }}</a
                >
              </div>
            </div>
            <hr />

            <div class="text-center">
              <input
                type="submit"
                class="btn btn-primary btn-sm w-100 mt-3 solid"
                name="submit"
                :value="$t('save')"
              />

              <button
                v-if="!user.is_guest && !isSSO"
                class="btn btn-default btn-sm w-100 mt-2 mb-2 solid"
                @click="logout()"
              >
                {{ $t("logout") }}
              </button>
            </div>

            <div class="profile-item">
              <div class="profile-label profile-tos">
                <a
                  @click="openTermsOfService()"
                  class="link-list text-primary small text-transform-none"
                  target="_blank"
                  >{{ $t("terms_of_service") }}</a
                >
              </div>
            </div>
            <div class="profile-item">
              <div class="profile-label profile-tos">
                <a
                  @click="openPrivacyPolicy()"
                  class="link-list text-primary small text-transform-none"
                  target="_blank"
                  >{{ $t("privacy_policy") }}</a
                >
              </div>
            </div>
          </main>
          <footer></footer>
        </div>
      </b-form>
    </b-overlay>
  </div>
</template>

<script>
import {
  AZC_ACCOUNT_URL,
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_URL
} from "../config/index";
import Api from "../core/Api";
import EventBus from "../core/EventBus";
const LanguageCodes = require("../plugins/languageCodes.json");

export default {
  name: "SettingsManagement",
  props: {},

  data() {
    return {
      form: {
        locale: this.$store.getters.getLocale
      },
      user: {},
      pending: false,
      supportedLanguages: ["en", "de"],
      isUserNameEdit: false,
      usernameError: null,
      isSSO: this.$store.getters.isSSO
    };
  },
  methods: {
    capitalizeWord(value) {
      value = value.toLowerCase();
      value = value[0].toUpperCase() + value.substring(1);
      return value;
    },
    close() {
      this.$emit("close");
    },
    logout() {
      new EventBus().broadcast("USER_LOGOUT");
    },
    deleteAccount() {
      const vm = this;
      vm.pending = true;

      this.$bvModal
        .msgBoxConfirm(this.$t("account_deletion_not_reversible"), {
          title: this.$t("delete_account_text"),
          modalClass: "last-delete-account",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          cancelVariant: "primary",
          okTitle: this.$t("yes"),
          cancelTitle: this.$t("no"),
          footerClass: "p-2 btn-group",
          hideHeaderClose: false,
          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            // Delete everything related to the user and logout
            Api.deleteUserAccount()
              .then(() => {
                vm.pending = false;
                // forward users to azc page
                // to delete his/her auth data.
                vm.$store.dispatch("logoutUser").then(() => {
                  window.open(`${AZC_ACCOUNT_URL}/privacy`, "_blank");
                });
              })
              .catch(err => {
                vm.pending = false;
                console.log(err.message);
              });
          } else {
            vm.pending = false;
          }
        })
        .catch(err => {
          console.log(err.message);
          vm.pending = false;
        });
    },
    downloadProfile() {
      this.$store.dispatch("fetchUserDownloadableDataLink").then(link => {
        window.open(link, "_blank");
      });
    },
    manageAzerionConnect() {
      window.open(AZC_ACCOUNT_URL, "_blank");
    },
    openTermsOfService() {
      window.open(TERMS_OF_SERVICE_URL, "_blank");
    },
    openPrivacyPolicy() {
      window.open(PRIVACY_POLICY_URL, "_blank");
    },
    changePassword() {
      window.open(`${AZC_ACCOUNT_URL}/password`, "_blank");
    },
    returnUsername() {
      this.isUserNameEdit = false;
      this.form.username = this.user.username;
    },
    onFormSubmit(e) {
      e.preventDefault();
      const vm = this;
      vm.pending = true;
      this.$store
        .dispatch("saveSettings", this.form)
        .then(() => {
          new EventBus().broadcast("NOTIFICATION", {
            success: true,
            message: vm.$t("success")
          });
          vm.close();
          vm.pending = false;
        })
        .catch(error => {
          this.usernameError = error[0].msg;
          new EventBus().broadcast("NOTIFICATION", {
            success: false,
            message: error[0].msg
          });
          vm.pending = false;
        });
    }
  },
  computed: {
    usernameValidation() {
      return !this.usernameError;
    }
  },
  beforeMount() {
    const vm = this;
    this.$store.dispatch("fetchUserInfo").then(user => {
      let newUser = JSON.parse(localStorage.getItem("gd_plus_user"));
      newUser.username = user.username;
      this.$store.state.user = newUser;

      vm.user = { ...vm.$store.getters.getUser, email: user.email };
      vm.form = {
        display_in_friendfinder: user.display_in_friendfinder === 1,
        newsletter: user.newsletter === 1,
        locale: this.$store.getters.getLocale,
        username: user.username
      };
    });

    const supportedLanguages = this.$store.getters.getGame.supportedLanguages.split(
      "|"
    );

    this.supportedLanguages = [];
    supportedLanguages.forEach(l => {
      const lang = LanguageCodes.find(x => x.code === l);
      this.supportedLanguages.push({
        value: l,
        text:
          lang.nativeName
            .trim()
            .charAt(0)
            .toUpperCase() + lang.nativeName.trim().slice(1)
      });
    });
  }
};
</script>
<style>
.CloseInputDiv {
  display: flex;
  align-items: center;
}
.sameIcon {
  color: #593989;
}
</style>
